const initialState = {
    schemeMobileNo:"",
    
    

};

const schemeMobileReducer = (state = initialState, { type, payload }) => {

    switch (type) {
        case "schemeMobile":
            return {
                ...state,
                schemeMobileNo: payload,
            };
           
        default:
            return state;
    }
};

export default schemeMobileReducer;
